import { useDialog } from "@datanac/datanac-mui-toolkit";
import { IconButton, Stack, Typography } from "@mui/material";
import { TilleyCard } from "components/Cards/TilleyCard";
import { DeleteIcon, MoneyIcon } from "components/Icons/Icons";
import { formatPrice } from "utility/formatters";

import { formatDate, formatPercentage } from "../../utility/formatters";

export default function EquipmentLoanCard({ loan, onEdit, onDelete }) {
  const { component: confirmDialogComponent, actions: confirmDialogActions } = useDialog();

  const handleDeleteOnClick = async () => {
    confirmDialogActions.confirm({
      title: "Delete this loan?",
      prompt: "Are you sure you want to delete this loan?",
      promptDetail: null,
      callback: () => {
        onDelete?.(loan);
      },
    });
  };

  const handleEditOnClick = () => {
    onEdit?.(loan);
  };

  const balance = loan?.amount ? formatPrice(loan.amount, 0) : "-";
  const schedule = loan?.payment_amount ? formatPrice(loan.payment_amount, 0) : "-";
  const maturityDate = loan?.maturity_date ? formatDate(loan.maturity_date) : "-";
  const rate = loan?.interest_rate ? formatPercentage(loan.interest_rate, 0) : "-";

  return (
    <>
      <TilleyCard
        data-testid={`loan-card-${loan?.id}`}
        Avatar={MoneyIcon}
        subtitle={loan?.creditor || <>&nbsp;</>}
        onClick={handleEditOnClick}
        title="Loan"
        action={
          <>
            <IconButton
              onClick={(e) => {
                e.stopPropagation();
                handleDeleteOnClick();
                return false;
              }}
            >
              <DeleteIcon />
            </IconButton>
          </>
        }
        customContent={
          <Stack
            direction="row"
            alignItems="center"
            justifyItems="center"
            sx={{
              flexWrap: "wrap",
              gap: { xs: 2, sm: 4 },
            }}
          >
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{balance}</Typography>
              <Typography variant="overline">Balance</Typography>
            </Stack>
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{rate}</Typography>
              <Typography variant="overline">Rate</Typography>
            </Stack>
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{schedule}</Typography>
              <Typography variant="overline">Schedule</Typography>
            </Stack>
            <Stack direction="column" spacing={1}>
              <Typography variant="subtitle2">{maturityDate}</Typography>
              <Typography variant="overline">Maturity Date</Typography>
            </Stack>
          </Stack>
        }
      />
      {confirmDialogComponent}
    </>
  );
}
